<div class="access-denied">
  <bodyanalytics-brand-logo [variant]="theme.isDark() ? 'dark' : 'light'" [height]="40" class="access-denied__logo" />

  @if (isRetryableError()) {
    <!--
      #2070 honest-error variant: the guard could not VERIFY the account
      (identity lookup 5xx / token failure), which is not an access decision.
      Telling a legitimate admin "Access Denied" here — or silently bouncing
      them to the login card — hides the real problem. Say what happened,
      offer a retry, keep the logout escape.
    -->
    <bodyanalytics-empty-state
      icon="bx-error-circle"
      heading="We couldn't load your account"
      message="Your sign-in worked, but the server didn't respond when we looked up your account. This is usually temporary.">
      <div empty-action class="access-denied__actions">
        <button type="button" class="btn btn-primary" (click)="retry()">Try again</button>
        <button type="button" class="btn btn-outline-primary" (click)="logout()">Log out</button>
      </div>
    </bodyanalytics-empty-state>
  } @else {
    <bodyanalytics-empty-state
      icon="bx-lock-alt"
      heading="Access Denied"
      message="You're signed in, but this account doesn't have access to the admin portal.">
      <div empty-action class="access-denied__actions">
        <button type="button" class="btn btn-primary" (click)="logout()">Log out</button>
        <button type="button" class="btn btn-outline-primary" (click)="signInDifferentAccount()">
          Sign in with a different account
        </button>
      </div>
    </bodyanalytics-empty-state>
  }

  <p class="access-denied__footer">
    Need help? <a href="mailto:support@appliedbiox.com">support&#64;appliedbiox.com</a>
  </p>
</div>
